import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { DigitalLibraryService } from 'app/infrastructure/services/digitalLibrary.service';
import { ItemDigitalLibrary } from 'app/infrastructure/model/classes/digitalLibrary.class';
import { AlertService } from 'app/infrastructure/services/alert.service';
import { DigitalLibraryProgressComponent } from './progress/digital-library-progress.component';
import { CountryTransform } from 'app/helpers/pipes/country.pipe';
import { DigitalLibraryItemTypes } from 'app/infrastructure/model/enum/digitalLibraryItemTypes.enum';
import { ItemLibrary } from 'app/infrastructure/model/classes/itemLibrary.class';


interface Filter {
  country: FilterItem[];
}

@Component({
  selector: 'app-desktop',
  templateUrl: './digital-library-list.component.html',
  styleUrls: ['./digital-library-list.component.css'],
})
export class DigitalLibraryListComponent implements OnInit {
  @Input() systemCode: string;
  @Input() channelCode: string;

  libraries: ItemDigitalLibrary[] = [];
  filteredLibraries: any[] = [];
  isLoading: Boolean = true;
  selectedLibrary: ItemDigitalLibrary = null;
  selectedLibraryId: number = null;
  insurances: any;
  groups: any[] = [];
  search = '';
  filters: Filter;

  selectedType = DigitalLibraryItemTypes.Product.valueOf();

  productType = DigitalLibraryItemTypes.Product.valueOf();
  templateType = DigitalLibraryItemTypes.Template.valueOf();

  @Output() onSelect: EventEmitter<ItemDigitalLibrary> = new EventEmitter<ItemDigitalLibrary>();

  constructor(private modalService: NgbModal,
    private aRoute: ActivatedRoute,
    private router: Router,
    public digitalLibraryService: DigitalLibraryService,
    private alertService: AlertService,
    private countryPipe: CountryTransform) { }

  ngOnInit() {
    this.systemCode = this.aRoute.snapshot.params.codsistema;
    this.channelCode = this.aRoute.snapshot.params.codnegocio;

    this.digitalLibraryService
      .getAll(this.systemCode)
      .subscribe(libraries => {

        if (libraries !== null) {
          this.libraries = libraries;
        }

        this.isLoading = false;
        this.grouping();
        this.resetFilters();
      });
  }

  grouping() {
    const objGroup = _(this.libraries).filter(l => l.type === this.selectedType).groupBy(
      library => this.countryPipe.transform(library.extraInfo.country)).value();
    const iterableGroup = Object.keys(objGroup).map((k) => objGroup[k]);
    iterableGroup.forEach(group => {
      this.groups.push(group);
    });
    this.filteredLibraries = this.groups;
  }

  importSelectedItem(itemLibrary: ItemLibrary) {
    switch (itemLibrary.type) {
      case this.productType:
        this.digitalLibraryService.importProductConfiguration(this.systemCode, this.channelCode, itemLibrary.id).then(
          transactionId => {
            let modal: NgbModalRef = null;
            const progressModal = DigitalLibraryProgressComponent;
            const ngbModalOptions: NgbModalOptions = {
              backdrop: 'static',
              keyboard: false,
            };

            modal = this.modalService.open(progressModal, ngbModalOptions);
            modal.componentInstance.systemCode = this.systemCode;
            modal.componentInstance.businessCode = this.channelCode;
            modal.componentInstance.transactionId = transactionId;
          });
        break;
      case this.templateType:
        this.router.navigate(['.', itemLibrary.id, 'import'], { relativeTo: this.aRoute });
        break;
    }
  }

  selectLibrary(library: ItemDigitalLibrary) {
    this.selectedLibraryId = library.id;
    this.selectedLibrary = library;
  }

  open(content) {
    // Back-up filters
    const copyFilters = _.cloneDeep(this.filters);

    this.modalService.open(content).result.then((result) => {
      this.applyFilter();
    }, (reason) => {
      // In case of dismiss or cancel, restore filters from backup
      this.filters = _.cloneDeep(copyFilters);
    });
  }

  resetFilters() {
    this.filters = {
      country: []
    };

    this.filteredLibraries.forEach(library => {
      library.forEach(item => {
        this.addIfNotExists(this.filters.country, item.extraInfo.country);
      });
    });
  }

  addIfNotExists(collection: FilterItem[], value: string) {
    const exists = collection.find(item => item.value === value);
    if (!exists) {
      collection.push({ value, selected: true });
    }
  }

  applyFilter() {
    this.applySearch();

    // Options Selected
    const selectedCountry = this.filters.country.filter(filter => filter.selected)
      .map(filter => filter.value);

    // Filter
    const categorias = [];
    this.groups.forEach(group => {

      group = group.filter(p => {
        return selectedCountry.includes(p.extraInfo.country);
      });

      if (group.length > 0) {
        categorias.push(group);
      }
    });

    this.groups = categorias;
  }

  librarySelected(library: ItemDigitalLibrary) {
    this.selectedLibrary = library;
  }

  applySearch() {
    this.groups = this.filteredLibraries;
  }

  filterByType(type) {
    this.selectedType = type;
    this.groups = [];
    this.grouping();
    this.resetFilters();
  }

 nuevo(){
    this.router.navigate(['../products/nuevo'], { relativeTo: this.aRoute });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/digital-library/digital-library-list.component.ts